import React, { useContext, useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { GblContext } from "providers/formatter";
import { Grid, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";
import MeterialtableTranslate from "components/MeterialtableTranslate";
import { callStoreReport } from "services/callStoreProcedure";

function DialogFolioDetail(props) {
  const theme = useTheme();
  const { pfmSeq, open, onClose } = props;
  const { NumberFormat, DateToString } = useContext(GblContext);
  const [Data, setData] = useState();
  const [isLoading, setLoading] = useState(true);
  const fetchSearchList = async () => {
    let p = {
      seqNo: pfmSeq,
    };
    const r = await callStoreReport("sp_GetArFolioDetail", p);
    setData(r);
    setLoading(false);
  };

  React.useEffect(() => {
    if (open) {
      fetchSearchList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, pfmSeq]);

  const columns = [
    {
      title: "Seq",
      field: "PfmSeq",
      sorting: false,
    },
    {
      title: "Invoice Date",
      field: "InvhDate",
      sorting: true,
      render: (rowData) => (rowData.InvhDate ? DateToString(new Date(rowData.InvhDate)) : null),
    },
    { title: "Invoice No.", field: "InvNo", sorting: true },
    { title: "Description", field: "Description", sorting: false },
    { title: "Remark", field: "Remark", sorting: false },
    {
      title: "Amount",
      field: "Amount",
      sorting: true,
      type: "numeric",
      render: (rowData) => NumberFormat(rowData.Amount),
    },
    {
      title: "Unpaid",
      field: "Unpaid",
      sorting: true,
      type: "numeric",
      render: (rowData) => NumberFormat(rowData.Unpaid),
    },
  ];

  const options = {
    draggable: false,
    headerStyle: {
      backgroundColor: theme.palette.primary.main,
      color: "#FFF",
    },
    rowStyle: (item) => {
      if (item.tableData.id % 2) {
        return { backgroundColor: "#f2f2f2" };
      }
    },
    padding: "dense",
    paging: false,
    selectionProps: () => ({
      color: "primary",
    }),
  };

  return (
    <Dialog fullWidth maxWidth="lg" aria-labelledby="confirmation-dialog-title" open={open}>
      <DialogTitle id="alert-dialog-title" style={{ padding: "10px 24px" }}>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          {"Folio Detail"}
          <IconButton color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <Divider />

      <DialogContent>
        <MeterialtableTranslate title="" columns={columns} data={Data} options={options} isLoading={isLoading} />
      </DialogContent>
      <br />
    </Dialog>
  );
}

export default DialogFolioDetail;
